import {
	Bar,
	BarChart,
	LabelList,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { numberFormatter } from "../../utils";
import { useState } from "react";
const TopSuppliersChart = (props: any) => {
	const [maxSpend, setMaxSpend] = useState(0);
	const chartData = props.data.map((i: any) => {
		if (maxSpend < i.additionalSpend) {
			setMaxSpend(i.additionalSpend);
		}
		if (i.master_vendor_name.length > 10) {
			let bigName = i.master_vendor_name.split(" ");
			if (bigName.length > 1) {
				i.shortName = bigName[0];
			} else {
				i.shortName = i.master_vendor_name.slice(0, 10) + "..";
			}
		} else {
			i.shortName = i.master_vendor_name;
		}
		i.incrementalBenefit = props.incrementalBenefit[i.master_vendor_name];
		return i;
	});
	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<div style={popupStyle}>
					{/* Header Row */}
					<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
						<div className="font-bold uppercase">Supplier:</div>
						<div
							className="font-bold ml-1"
							style={{ color: "#3f3f3f" }}
						>
							{data.master_vendor_name}
						</div>
					</div>
					{/* Data Rows */}
					<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
						{data.currentSpend > 0 && (
							<p style={{ padding: "0", margin: "0 0 5px 0" }}>
								<span
									className="graph-label-small"
									style={{
										color: "#5a5a5a",
										fontWeight: "normal",
									}}
								>
									Current Spend ($):{" "}
								</span>
								<span
									className="graph-label-small"
									style={{
										color: "#3f3f3f",
										fontWeight: "bold",
									}}
								>
									{numberFormatter(data.currentSpend, 0)}
								</span>
							</p>
						)}
						{data.additionalSpend > 0 && (
							<p style={{ padding: "0", margin: "0" }}>
								<span
									className="graph-label-small"
									style={{
										color: "#5a5a5a",
										fontWeight: "normal",
									}}
								>
									Additional Spend ($):{" "}
								</span>
								<span
									className="graph-label-small"
									style={{
										color: "#3f3f3f",
										fontWeight: "bold",
									}}
								>
									{numberFormatter(data.additionalSpend, 0)}
								</span>
							</p>
						)}
					</div>
				</div>
			);
		}
		return null;
	};

	const renderCustomizedLabel = (props: any, d: any) => {
		const { x, y, width, value, name } = props;
		return (
			<text fill="black" fontSize={16}>
				<tspan x="0" dy="1.6em">
					Incremental Benefits
				</tspan>
			</text>
		);
	};
	return (
		<div className="w-full h-full">
			<ResponsiveContainer width="100%" height="96%">
				<BarChart
					data={chartData}
					// margin={{
					// 	top: 30,
					// 	right: 10,
					// 	bottom: 0,
					// 	left: 10,
					// }}
				>
					<XAxis
						dataKey="shortName"
						className="graph-label "
						stroke="black"
					/>
					<YAxis
						className="graph-label "
						stroke="black"
						tickFormatter={(value: number) =>
							numberFormatter(value, 0, "$")
						}
					/>
					<Tooltip
						contentStyle={{
							color: "#000",
							backgroundColor: "#fff",
							padding: "10px",
							borderRadius: "5px",
							border: "1px solid #ccc",
						}}
						wrapperStyle={{
							overflow: "visible",
							zIndex: 1000,
						}}
						cursor={{ strokeDasharray: "3 3", fill: "#F1F1F1" }}
						content={customTooltip}
					/>
					<Bar
						dataKey="currentSpend"
						stackId="a"
						fill="#62B5E5"
						barSize={60}
					>
						<LabelList
							dataKey="currentSpend"
							fill="white"
							className="graph-label-new"
							formatter={(value: number) =>
								value == 0
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
					<Bar
						dataKey="additionalSpend"
						stackId="a"
						fill="#012169"
						barSize={80}
					>
						<LabelList
							dataKey="additionalSpend"
							fill="white"
							className="graph-label-new"
							formatter={(value: number) =>
								value == 0 || value < maxSpend / 4
									? null
									: numberFormatter(value, 0, "$")
							}
							position="center"
						></LabelList>
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};
export default TopSuppliersChart;
